function Home() {
  return (
    <>
      <h1>Hey there, I'm Mariah Lara,</h1>
      <img
        src="https://i.imgur.com/5q30Hfe.png"
        className="waterfallphoto"
        alt="myphoto"
      />

      <h2>
        A full-stack Software Engineer with an insatiable curiosity that fuels
        my ambition to learn more. I have extensive experience in developing
        dynamic and interactive web applications using technologies such as
        HTML, CSS, JavaScript, React, TypeScript, Mongoose, MongoDB, Node, and Google OAuth.
      </h2>
      <h2>
        I take great pleasure in building and developing software, even if the
        end result may not be perfect. The process of learning and creating is
        what I find most enjoyable and satisfying, and my curiosity fuels this
        enjoyment as I am constantly seeking to learn and improve my skills.
      </h2>
      <h2>
        I am proud to be a Latina and a member of the Latinas in Tech Miami
        chapter, where I celebrate and embrace my heritage and culture.
      </h2>
    </>
  );
}

export default Home;
